import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=36981818&scoped=true"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=36981818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36981818",
  null
  
)

export default component.exports